import { MutationTree } from "vuex";
import {
  updateUserInfo,
  updateStundentInfo,
  launchMiniapp,
  closeBarCodeView,
  resetUserInfo
} from "./mutation-types";
import { UserState } from "@/interface";
import { getBarcodePath } from "@/helper/weChatHelper";
import { initState } from "./constants";

export const mutations: MutationTree<UserState> = {
  [resetUserInfo]: (state: UserState) => {
    console.log("resetUserInfo");
    Object.assign(state, initState);
    console.log(state);
  },
  [updateUserInfo]: (state: UserState, payload: any) => {
    console.log("updateUserInfo:", payload);
    if (payload) {
      Object.assign(state, payload);
    }
    state.loaded = true;
  },
  [updateStundentInfo]: (state: UserState, payload: any) => {
    console.log("updateStundentInfo:", payload);
    if (payload) {
      Object.assign(state, payload);
    }
  },
  [launchMiniapp]: (state: UserState, payload: boolean) => {
    state.miniappBarcodePath = getBarcodePath(payload);
  },
  [closeBarCodeView]: (state: UserState) => {
    state.miniappBarcodePath = undefined;
  }
};
